module.exports = __webpack_public_path__ + "img/icon-search.684ff123.svg";